//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormulateInputMixin from '../FormulateInputMixin'

export default {
  name: 'FormulateInputBox',
  mixins: [FormulateInputMixin],
  computed: {
    usesDecorator () {
      return this.$formulate.options.useInputDecorators
    }
  }
}
